import { Text, TextInput, View } from "react-native";
import { color_333333, color_BEBEBE, color_F1F1F1, color_main, ColorGrey, ColorLine, white } from "../assets/style/colors";
import BaseScreen from "./BaseScreen";
import { MainNavProps } from "./navigation/main/MainParamList";
import NavBar from "../components/NavBar";
import { Str_AddFriends, Str_ApplyJoinGroup, Str_JoinGroupPlace, Str_Send, Str_ApplySuc } from "../language/string_res";
import { useState } from "react";
import * as ImSdk from "../../imsdk/api";
import { showDialog } from "../components/CommonDialog";
import { showToast } from "../components/Toast";
import { postJson } from "../net/http";

export type ScannerApplyProps = {
    type: "Group" | "User"
    touid?: number,
    tid?: string,
    code: string,
}

export const ScannerApplyScreen = ({ navigation, route }: MainNavProps<'ScannerApplyScreen'>) => {
    const { type, tid, touid, code } = route.params
    const title = type === 'Group' ? Str_ApplyJoinGroup : Str_AddFriends
    const placeholder = Str_JoinGroupPlace
    const [value, setValue] = useState('');
    const currentUid = ImSdk.getInstance().CurrentUid();
    function onClick() {
        let body: any;
        let url;
        if (type === 'Group') {
            body = { tid: tid, hello: value, code: code, members: [currentUid] }
            url = "/v1/sdk/group/qrcode/apply/add"
        } else {
            body = { hello: value, touid: touid, scene: 'qr', code: code }
            url = "/v1/sdk/user/qrcode/apply/add"
        }
        postJson(url, { body: body }).then((res) => {
            if (res.code === 0) {
                showDialog({
                    message: Str_ApplySuc,
                    outDismiss: false,
                    onConfirm: () => {
                        navigation.goBack()
                    }
                })
            } else {
                if (res.msg) {
                    showToast(res.msg)
                }
            }
        })
    }
    return (
        <BaseScreen styles={{ backgroundColor: white }}>
            <NavBar
                title={title}
                showBack={true}
                rightClick={onClick}
                rightChildren={
                    <Text style={{
                        color: color_main,
                        fontSize: 16,
                    }}>
                        {Str_Send}
                    </Text>
                } />

            <TextInput
                placeholder={placeholder}
                multiline={true}
                textAlignVertical="top"
                value={value}
                placeholderTextColor={color_BEBEBE}
                onChangeText={setValue}
                style={{
                    padding: 15,
                    color: color_333333,
                    fontSize: 18,
                    height: 135,
                    marginTop: 10,
                    overflow: 'hidden',
                    backgroundColor: color_F1F1F1,
                    marginHorizontal: 12,
                    borderRadius: 12,
                }}
            />

        </BaseScreen>)
}